<script>
</script>

<div class="fieldgroup" {...$$props}>
  <slot />
</div>
